import { NEWBUILDING_KPN_CHAT } from 'node/services/fetchExperiments/getExperiments';
import { NEWBUILDING_BOOKING_AUTH_EXPERIMENT } from 'shared/selectors/abExperiments';

export const EXPERT_OPINION = 'aud_desktop_bx495_expert_opinion_gpt_newb';
export const REPLACEMENT_BUTTON_UNDER_PRICE_EXPERIMENT = 'b2c_txn963_replacement_button_under_price_web';

export const EXPERIMENTS: string[] = [
  EXPERT_OPINION,
  REPLACEMENT_BUTTON_UNDER_PRICE_EXPERIMENT,
  NEWBUILDING_KPN_CHAT,
  NEWBUILDING_BOOKING_AUTH_EXPERIMENT,
];
